import common from './common/_index';

addEventListener('DOMContentLoaded', (): void => {
  // 全ページ共通で行う処理を実行
  common();

  const headerNav = document.querySelector('.l-header__nav');
  const headerNavHead = document.querySelector('.l-header__nav-head');

  headerNavHead?.addEventListener('click', () => {
    headerNav?.classList.toggle('is-open');
  });
});
